import Vue from 'vue'
import Vuex from 'vuex'
import router, { clearLoginState } from '@/router/router'

//1.安装插件
Vue.use(Vuex)

//2.创建对象
const store = new Vuex.Store({
  //数据，相当于data
  state: {

  },
  getters: {

  },
  //里面定义方法，操作state方发
  mutations: {
    // 退出登录：清 token + 清菜单缓存 + 重置动态路由，然后回登录页
    layout() {
      clearLoginState();
      if (router.currentRoute.path !== '/login') {
        router.push({ path: '/login' });
      }
    },

  },
  // 操作异步操作mutation
  actions: {

  },
  modules: {

  },


})
//3.导出使用
export default store



// WEBPACK FOOTER //
// ./src/store/index.js